import { render, staticRenderFns } from "./CopyBooklist.vue?vue&type=template&id=cfcd16e6"
import script from "./CopyBooklist.vue?vue&type=script&lang=js"
export * from "./CopyBooklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports